// Claymorphism Color Palette (matched with CTCI Banner)
export const claymorphismColors = {
  // Primary colors (from Banner)
  softOrange: '#FFDAB3',   // Banner 橘色淡化版 - 主色
  softGold: '#FFF3CD',     // Banner 金黃淡化版 - 輔助色
  softCyan: '#E0F7FA',     // Banner 青藍淡化版 - 強調色

  // Legacy colors (kept for compatibility)
  softPeach: '#FDBCB4',
  babyBlue: '#ADD8E6',
  mint: '#98FF98',
  lilac: '#E6E6FA',
  lightPeach: '#FFE5D9',
  lightMint: '#C8F7C5',
  lightBlue: '#D4F1F9',

  // Text colors
  text: '#1A1A2E',         // High contrast for readability
  textLight: '#424242',    // Banner 深灰色

  // Accent (from Banner orange)
  accent: '#E85D04',       // Banner 原始橘色

  // Error/Warning colors
  errorRed: '#B71C1C',     // Material Design Red 900 - high contrast for warnings
  errorRedLight: 'rgba(183, 28, 28, 0.1)',  // Light red background for warning areas
};

export default claymorphismColors;
